import { toast } from "react-toastify";
import Button from "../../../componentes/button/button";
import { formatarDataHora } from "../../../utils/solicitacoes/formatters";

/**
 * Botão "Salvar rascunho" (fica no cabeçalho da Nova Solicitação, à direita do título) com a hora do
 * último salvamento. O estado vem de useRascunho (página); aqui é só apresentação.
 */
export function RascunhoBotao({ ultimoSalvamento, onSalvar }) {
    function salvar() {
        const resultado = onSalvar();
        if (resultado?.ok) toast.success("Rascunho salvo neste navegador.");
        else if (resultado) toast.error(`Não foi possível salvar o rascunho: ${resultado.motivo}.`);
    }

    return (
        <div className="flex flex-col items-end gap-1 shrink-0">
            <Button variant="outline" label="Salvar rascunho" iconLeft="fa fa-save" onClick={salvar} />
            {ultimoSalvamento && (
                <span className="text-xs text-muted-foreground">
                    <i className="fa fa-check text-green-600 mr-1" />
                    Salvo neste navegador às {formatarDataHora(ultimoSalvamento)}
                </span>
            )}
        </div>
    );
}

/** Aviso, acima do formulário, de que há um rascunho salvo para retomar ou descartar. */
export function RascunhoAviso({ rascunhoPendente, onRestaurar, onDescartar }) {
    if (!rascunhoPendente) return null;

    function descartar() {
        if (window.confirm("Descartar o rascunho salvo? Essa ação não pode ser desfeita.")) onDescartar();
    }

    return (
        <div className="flex flex-wrap items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2.5">
            <i className="fa fa-file-alt text-primary" />
            <span className="text-sm text-foreground flex-1 min-w-[12rem]">
                Você tem um rascunho desta solicitação salvo em <strong>{formatarDataHora(rascunhoPendente.salvoEm)}</strong>.
                <span className="block text-xs text-muted-foreground">Anexos não ficam no rascunho — anexe-os novamente.</span>
            </span>
            <div className="flex gap-2">
                <Button variant="outline" label="Descartar" iconLeft="fa fa-trash" onClick={descartar} />
                <Button variant="blue" label="Retomar rascunho" iconLeft="fa fa-undo" onClick={onRestaurar} />
            </div>
        </div>
    );
}
